import { VueModule } from '@Foundation/utilities';
import questionAnsSchemaMarkup from './code/Scripts/components/question-ans-schema-markup.vue';

export default VueModule({
    components: {
        questionAnsSchemaMarkup
    }
});